// import node module libraries
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Badge, ListGroup, Dropdown } from 'react-bootstrap';

// import bootstrap icons
import { Braces, CurrencyEuro } from 'react-bootstrap-icons';

// import translation
import { useTranslation } from 'react-i18next';
import { List } from 'react-feather';

const FlowSummary = ({ item }) => {
	const { t } = useTranslation();

	return (
		<Card>
			<Card.Header className="card-header">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<h4 className="mb-0">{t('Flow Information')}</h4>
					</div>
					<div className="position-absolute top-0 end-0 p-3">
						{item.marketplace_value.premium ? <Badge bg="primary">{t('Premium')}</Badge> : <Badge bg="secondary">{t('Standard')}</Badge>}
					</div>
				</div>
			</Card.Header>
			<Card.Body>
				<p>
					{item.marketplace_value.description}
				</p>
				<ListGroup variant="flush">
					<ListGroup.Item className="px-0">
						<div className="d-flex justify-content-between align-items-center">
							<div className="d-flex align-items-center">
								<Braces size={16} className="text-primary" />
								<div className="ms-2">
									<h5 className="mb-0 text-body">{t('Features')}</h5>
								</div>
							</div>
							<div>
								<div className="text-dark mb-0 fw-semi-bold">
									<ListGroup variant="flush" as="ul" bsPrefix="list-group" className="mb-3 mt-2 text-muted">
										{item.marketplace_value.features && item.marketplace_value.features.map((feature, index) => (
											<ListGroup.Item as="li" bsPrefix="" className="text-dark align-self-end" key={index}>
												<i className="fe fe-arrow-right"></i>
												{t(feature)}
											</ListGroup.Item>
										))}
									</ListGroup>
								</div>
							</div>
						</div>
					</ListGroup.Item>
					<ListGroup.Item className="px-0">
						<div className="d-flex justify-content-between align-items-center">
							<div className="d-flex align-items-center">
							<CurrencyEuro size={16} className="text-primary" />
								<div className="ms-2">
									<h5 className="mb-0 text-body">{t('Costs')}</h5>
								</div>
							</div>
							<div>
								<p className="text-dark mb-0 fw-semi-bold">
									{item.marketplace_value.price - item.marketplace_value.discount > 0 ?
										(<>
											<span className="text-dark">
												{item.marketplace_value.price - item.marketplace_value.discount}€
											</span>
											<del className={`fs-6 text-muted ${item.marketplace_value.discount <= 0 ? 'd-none' : ''} `}>{item.marketplace_value.price}€</del>
											<span className="align-self-end text-muted fs-6 mb-1 ms-2 toggle-price-content">
												/{t('Month')}
											</span>
										</>) :
										(<span className="text-dark fs-3">{t('for free')}</span>)
									}
								</p>
							</div>	
						</div>
					</ListGroup.Item>
				</ListGroup>
			</Card.Body>
		</Card>
	);
};

export default FlowSummary;
